// 私有 - 任务管理列表 - 搜索数据
export const searchs = [
  [{
      label: '任务编号',
      value: '',
      placeholder: '请输入任务名称',
      type: 'ipt',
      field: 'id'
    },
    {
      label: '任务名称',
      value: '',
      placeholder: '请输入任务负责人',
      type: 'ipt',
      field: 'name'
    },
    {
      label: '任务负责人',
      value: '',
      placeholder: '请输入项目名称',
      type: 'sel',
      field: 'leader_user_id',
      list: []
    },
    {
      label: '业务状态',
      value: -1,
      placeholder: '请输入任务状态',
      type: 'sel',
      field: 'task_status',
      list: [{
        id: -1,
        name: '全部'
      }, {
        id: 0,
        name: '未提交'
      }, {
        id: 10,
        name: '未审核'
      }, {
        id: 20,
        name: '未下推'
      }, {
        id: 30,
        name: '已结束'
      }]
    },
    {
      label: '审核状态',
      value: -1,
      placeholder: '请输入审核状态',
      type: 'sel',
      field: 'examine_status',
      list: [{
        id: -1,
        name: '全部'
      }, {
        id: 0,
        name: '排期等待'
      }, {
        id: 10,
        name: '进行中'
      }, {
        id: 20,
        name: '暂停'
      }, {
        id: 30,
        name: '已结束'
      }]
    },
  ],
  [{
      label: '完成日期',
      value: '',
      placeholder: '请输入默认供应商',
      type: 'date',
      field: 'end_time'
    },
    {
      label: '预计开始日期',
      value: '',
      placeholder: '请输入默认供应组织',
      type: 'date',
      field: 'plan_start_time'
    },
    {
      label: '所属项目名称',
      value: '',
      placeholder: '请输入默认供应组织',
      type: 'ipt',
      field: 'project_name'
    },
    {
      label: '空',
      type: 'spec'
    },
    {
      type: 'searchReset',
      url: 'v1/product',
    }
  ]
]

// 私有 表格 - columns
export const tableColumns = [{
    type: 'checkbox',
    align: 'center',
    width: '50'
  },
  {
    type: 'text',
    field: 'sn',
    title: '任务编号',
    width: '100',
    align: 'center'
  },
  {
    type: 'router',
    field: 'project_name',
    title: '所属项目名称',
    width: '280',
    align: 'left'
  },
  {
    type: 'text',
    field: 'name',
    title: '任务名称',
    width: '180',
    align: 'left'
  },
  {
    type: 'text',
    field: 'leader_user_name',
    title: '任务负责人',
    width: '120',
    align: 'left'
  },
  {
    type: 'text',
    field: 'reviewer_user_name',
    title: '任务审核人',
    width: '120',
    align: 'left'
  },
  {
    type: 'text',
    field: 'task_status_text',
    title: '业务状态',
    width: '120',
    align: 'left'
  },
  {
    type: 'text',
    field: 'examine_status_text',
    title: '审核状态',
    width: '120',
    align: 'left'
  },
  {
    type: 'text',
    field: 'plan_start_time_text',
    title: '预计开始日期',
    width: '220',
    align: 'left'
  },
  {
    type: 'text',
    field: 'end_time_text',
    title: '任务完成日期',
    width: '',
    align: 'left'
  },
]

// 私有 表格 - 默认值
export const tableDefaultVal = [{
  id: null, // 任务编码
  project_name: '', //所属项目名称
  name: '', // 任务名称
  leader_user_name: '', //任务负责人
  reviewer_user_name: '', // 任务审核人
  task_status: '', // 业务状态
  examine_status: '', // 审核状态
  plan_start_time: '', // 预计开始时间
  start_time: '', // 任务开始时间
  end_time: '', // 任务结束时间
}]

// 私有 表头按钮
export const tableHeaderBtns = [{
    name: '状态操作',
    type: 'oper_status',
    style_self: 'btn_y_drag',
    color: true,
    drag: [{
      id: 1,
      name: '排期',
      type: 'pq'
    }, {
      id: 2,
      name: '转派',
      type: 'zp'
    }, {
      id: 3,
      name: '暂停',
      type: 'zt'
    }]
  },
  {
    name: '提交',
    type: 'oper_commit',
    style_self: 'btn_y_drag',
    color: true,
    drag: [{
      id: 1,
      name: '提交',
      type: 'tj'
    }, {
      id: 2,
      name: '撤消',
      type: 'cx'
    }]
  },
  {
    name: '通过',
    type: 'pass',
    style_self: 'btn_n_drag',
    color: true
  },
  {
    name: '人员变更',
    type: 'sel_single',
    style_self: 'btn_n_drag',
    color: true
  },
  // {name:'我的待办',type:'check_box',style_self:'btn_checkout'}
]

export const _data = {
  // 搜索组
  diySerach: [],
  noticedata: 1,
  options: [],
  searchQuery: {},
  selRow: [],
  my: 1,
  // 表格
  listHeader: [],
  defaultRow: [],
  mergeColData: [],
  tableHeader: [],
  beforeStrList: [],
  tasklsittable: [],
  staticList: {
    mtlist: []
  },
  notShowCol: [],
  singleChangeList: [],
  singleLabel: '任务审核人',
  singleTitle: '人员变更',
  storeJointIds: '',
  tableHeigth: 600,
  // 分页
  page: 1,
  size: 10,
  count: 0,
  // 共公弹窗
  LcSingleIndex: 1,
  isShowDialog: false,
  dia_type: null,
  dia_label: '',
  dia_title: '',
  dia_list: []
}